import styled from "styled-components";
import React, { Component } from "react";
import PropTypes from "prop-types";
import colors from "../../utils/colors";
import TweenLite from "gsap";
import { EASE } from "../../utils/easing";
import Icon from "../../icons/Icon";
import { ICONS } from "../../icons/Icons";
import * as _ from "lodash";

const Container = styled.div`
  position: absolute;
  top: 15px;
  left: 45%;

  .star {
    position: absolute;
    opacity: 0;
  }
`;

class ScoreStars extends Component {
  stars = [];
  animationLimit = 0;
  score = null;

  componentDidMount() {
    // console.log('ScoreStars componentDidMount', this.props);
    this.stars = [
      this.star0,
      this.star1,
      this.star2,
      this.star3,
      this.star4,
      this.star5,
      this.star6,
      this.star7,
      this.star8,
      this.star9
    ];
    this.score = this.props.score;
  }

  componentWillReceiveProps(nextProps) {
    // console.log('ScoreStars willReceiveProps', nextProps);
    if (nextProps.percent > this.animationLimit && this.score !== nextProps.score) {
      this.score = nextProps.score;
      this.animate();
    }
  }

  componentWillUnmount() {
    _.each(this.stars, function(star) {
      TweenLite.killTweensOf(star);
    });
  }

  animate = () => {
    this.clearStars();

    const time = 1.75;
    const delay = 0.07;
    const len = this.stars.length;
    for (let i = 0; i < len; i++) {
      const star = this.stars[i];
      TweenLite.to(star, 0, { opacity: 1, delay: delay });
      if (i === len - 1) {
        TweenLite.to(star, time, {
          x: this.randX(i),
          y: this.randY(star),
          opacity: 0,
          delay: delay,
          ease: EASE.easeIn,
          onComplete: this.clearStars
        });
      } else {
        TweenLite.to(star, time, {
          x: this.randX(i),
          y: this.randY(star),
          opacity: 0,
          delay: delay,
          ease: EASE.easeIn
        });
      }
    }
  };

  clearStars = () => {
    const len = this.stars.length;
    for (let i = 0; i < len; i++) {
      TweenLite.to(this.stars[i], 0, { x: 0, y: 0, opacity: 0 });
    }
  };

  randX = position => {
    if (position <= this.stars.length / 2) {
      return Math.round(Math.random() * -250);
    }
    return Math.round(Math.random() * 250);
  };

  randY = target => {
    const r = target.getBoundingClientRect();
    return -r.height - Math.round(Math.random() * 250);
  };

  render() {
    return (
      <Container>
        <div className="star" ref={r => (this.star0 = r)}>
          <Icon
            icon={ICONS.STAR}
            width="20px"
            height="20px"
            fill={colors.BRAND_RED_LIGHT}
            stroke={colors.WHITE}
            strokeWidth={"1px"}
          />
        </div>

        <div className="star" ref={r => (this.star1 = r)}>
          <Icon
            icon={ICONS.STAR}
            width="25px"
            height="25px"
            fill={colors.BRAND_RED_LIGHT}
            stroke={colors.WHITE}
            strokeWidth={"1px"}
          />
        </div>

        <div className="star" ref={r => (this.star2 = r)}>
          <Icon
            icon={ICONS.STAR}
            width="30px"
            height="30px"
            fill={colors.BRAND_RED_LIGHT}
            stroke={colors.WHITE}
            strokeWidth={"1px"}
          />
        </div>

        <div className="star" ref={r => (this.star3 = r)}>
          <Icon
            icon={ICONS.STAR}
            width="50px"
            height="50px"
            fill={colors.BRAND_RED_LIGHT}
            stroke={colors.WHITE}
            strokeWidth={"1px"}
          />
        </div>

        <div className="star" ref={r => (this.star4 = r)}>
          <Icon
            icon={ICONS.STAR}
            width="70px"
            height="70px"
            fill={colors.BRAND_RED_LIGHT}
            stroke={colors.WHITE}
            strokeWidth={"1px"}
          />
        </div>

        <div className="star" ref={r => (this.star5 = r)}>
          <Icon
            icon={ICONS.STAR}
            width="70px"
            height="70px"
            fill={colors.BRAND_RED_LIGHT}
            stroke={colors.WHITE}
            strokeWidth={"1px"}
          />
        </div>

        <div className="star" ref={r => (this.star6 = r)}>
          <Icon
            icon={ICONS.STAR}
            width="90px"
            height="90px"
            fill={colors.BRAND_RED_LIGHT}
            stroke={colors.WHITE}
            strokeWidth={"1px"}
          />
        </div>
        <div className="star" ref={r => (this.star7 = r)}>
          <Icon
            icon={ICONS.STAR}
            width="20px"
            height="20px"
            fill={colors.BRAND_RED_LIGHT}
            stroke={colors.WHITE}
            strokeWidth={"1px"}
          />
        </div>

        <div className="star" ref={r => (this.star8 = r)}>
          <Icon
            icon={ICONS.STAR}
            width="40px"
            height="40px"
            fill={colors.BRAND_RED_LIGHT}
            stroke={colors.WHITE}
            strokeWidth={"1px"}
          />
        </div>

        <div className="star" ref={r => (this.star9 = r)}>
          <Icon
            icon={ICONS.STAR}
            width="30px"
            height="30px"
            fill={colors.BRAND_RED_LIGHT}
            stroke={colors.WHITE}
            strokeWidth={"1px"}
          />
        </div>
      </Container>
    );
  }
}

ScoreStars.propTypes = {
  score: PropTypes.number,
  percent: PropTypes.number
};

ScoreStars.defaultProps = {
  score: null,
  percent: 0
};

export default ScoreStars;



// WEBPACK FOOTER //
// ./src/ui/score/ScoreStars.js